import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { SecurityaddonsService } from '../../securityaddons/services/securityaddons.service';
import { IdentityService } from '../services/identity.service';

@Injectable({
    providedIn: 'root',
})
class TermsAndConditionsGuardService {
    constructor(
        private authService: AuthService,
        private identityService: IdentityService,
        private securityAddOnService: SecurityaddonsService,
        private router: Router,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const user = this.authService.jwtUser;

        const getTermsAccepted = localStorage.getItem('acceptedTC');

        if ((user && user.meta.termsAndConditionsAccepted) || getTermsAccepted === 'true') {
            return true;
        }

        return this.router.parseUrl('/terms-and-conditions');
    }
}

export const TermsAndConditionsGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
    return inject(TermsAndConditionsGuardService).canActivate(next, state);
};
